/** Set only in the approved tester's tab, never in URLs, source, logs or build settings. */
export function openAiTesterSession(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const value = window.sessionStorage.getItem("lecmo_oai_live_test_session");
    return value && /^[A-Za-z0-9_-]{43}$/.test(value) ? value : null;
  } catch {
    return null;
  }
}
